import './App.css';
import BgRemove from './components/BgRemove';
import Header from './components/Header';

function App() {
  return (
    <div className="App">
      <Header/>
      <BgRemove/>
    </div>
  );
}

export default App;
